import React, { useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
const outsideClickDetectorPropTypes = {
  onClickOutside: PropTypes.func,
  onWindowBlur: PropTypes.func
};
export const OutsideClickDetector = ({
  children: renderProp,
  onClickOutside,
  onWindowBlur
}) => {
  const node = useRef();
  const handleClick = useCallback(event => {
    if (node.current.contains(event.target)) {
      return;
    }
    if (onClickOutside) {
      onClickOutside(event);
    }
  }, [onClickOutside]);
  const handleWindowBlur = useCallback(event => onWindowBlur && onWindowBlur(event), [onWindowBlur]);
  useEffect(() => {
    window.addEventListener('blur', handleWindowBlur);
    document.addEventListener('mousedown', handleClick);
    return () => {
      window.removeEventListener('blur', handleWindowBlur);
      document.removeEventListener('mousedown', handleClick);
    };
  }, [handleClick, handleWindowBlur]);
  return renderProp(ref => {
    node.current = ref;
  });
};
OutsideClickDetector.propTypes = outsideClickDetectorPropTypes;